import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diretos-correcao',
  templateUrl: './diretos-correcao.component.html',
  styleUrls: ['./diretos-correcao.component.scss'],
})
export class DiretosCorrecaoComponent implements OnInit {
  itemDados: boolean;
  itemPositivos: boolean;
  itemCadastrais: boolean;

  constructor() {
    this.itemDados = true;
  }

  ngOnInit(): void {
    parent.scroll(0, 0);
  }

  menuAtivo(menu: string) {
    switch (menu) {
      case 'dados':
        this.itemDados = true;
        this.itemPositivos = false;
        this.itemCadastrais = false;
        break;
      case 'positivos':
        this.itemPositivos = true;
        this.itemDados = false;
        this.itemCadastrais = false;
        break;
      case 'cadastrais':
        this.itemCadastrais = true;
        this.itemDados = false;
        this.itemPositivos = false;
        break;
    }
  }

  redirectCentralAjudaTicket(): void {
    window.open(
      'https://ajuda.serasa.com.br/hc/pt-br/requests/new?ticket_form_id=360000039951',
      '_blank'
    );
  }

  redirectPaginaCadPositivo(): void {
    window.open(
      'https://portal.cadastropositivo.com.br/ficadpf/#_ga=2.193807598.210847816.1603213924-268396402.1603213924',
      '_blank'
    );
  }

  redirectPaginaAgenProxima(): void {
    window.open('https://www.serasa.com.br/atendimento-presencial', '_blank');
  }
}
